export const WXR_VERSION = '1.2'

export const PAGE_TEMPLATE_META_KEY = '_wp_page_template'
export const PAGE_TEMPLATE_META_VALUE = 'default'

export const YOAST_META_KEYS = {
  description: '_yoast_wpseo_metadesc',
  focusKeyword: '_yoast_wpseo_focuskw',
  title: '_yoast_wpseo_title',
} as const

export const RANK_MATH_META_KEYS = {
  description: 'rank_math_description',
  focusKeyword: 'rank_math_focus_keyword',
  title: 'rank_math_title',
} as const

export const RANK_MATH_KEYWORDS_LIMIT = 5
